import ClinicSettingsWrapper from './ClinicSettingsWrapper';

export default ClinicSettingsWrapper;
